/*

        Windows Media Player detection script  v0.4
        By Eric Gerds   http://www.pinlady.net/PluginDetect/

 Note:
  1) In your web page, load the PluginDetect script BEFORE you load this script.
  2) In your web page, have the output <div> BEFORE this script. The <div> looks like this:
       <div id="detectWMP_output"></div>
  3) Feel free to modify this script as you wish.
  4) If you wish to use the plugindetect <div>, then insert it into the <body>,
     anywhere BEFORE the plugin detection begins.
     This <div> temporarily holds any plugin object that is inserted into the web page,
     but only when needed for detection.
     For example:
        <div id="plugindetect" style="right:0px; top:0px; position:absolute;"></div>
     This step is optional, as PluginDetect will create and insert the <div> automatically 
     when needed.


*/


// Detect the plugin
(function(){
  
 // Return text message based on plugin detection result
 var getStatusMsg = function(obj)
 {
   if (obj.status==1) return "installed & enabled, version is >= " + obj.minVersion;
   if (obj.status==0) return "installed & enabled, version is unknown";
   if (obj.status==-0.1) return "installed & enabled, version is < " + obj.minVersion;
   if (obj.status==-0.2) return "installed but not enabled";
   if (obj.status==-1) return "not installed or not enabled";
   if (obj.status==-3) return "error...bad input argument to PluginDetect method";
   return "unknown";
 };   // end of function

 var out = document.getElementById("detectWMP_output");  // node for output text

 // Add text to output node
 var docWrite = function(text)
 {
     if (out)
     {
        if (text)
        {
          text = text.replace(/&nbsp;/g,"\u00a0");
          out.appendChild(document.createTextNode(text));
        };
        out.appendChild(document.createElement("br"));
     };
 };  // end of function



 // Object that holds all data on the plugin
 var P = {name:"WindowsMediaPlayer", mime:"", status:-1, version:null, minVersion:"11,0,0,0"};

 var $ = PluginDetect, 

   // The 'instantiate' input argument only affects non-Internet Explorer browsers.
   // 
   // When 'instantiate' is undefined or false, then PluginDetect will detect
   // the presence of the plugin. However, the plugin version may not be detected,
   // since the version # is often not present in the navigator.plugins[] array.
   // There should not be any security popup messages generated by any browsers
   // during this plugin detection.
   //
   // When 'instantiate' is true, then an instance of the plugin will be inserted into
   // the DOM. This may cause a security popup message to appear in some browsers 
   // asking for permission to run the plugin (if the plugin is outdated or insecure).
   // If or when the plugin runs, then this plugin instance will be queried by
   // PluginDetect to get the exact plugin version.
   //
   // Note: For Internet Explorer, the plugin version will always be detected regardless
   // of the value of 'instantiate'.
   instantiate=false;



 // Detect WMP Version
 if ($.getVersion)
 {
    P.version = $.getVersion(P.name, instantiate);
    docWrite("Plugin version: " + P.version);
 };
   

 // Detect Plugin Status
 if ($.isMinVersion)
 {
   P.status = $.isMinVersion(P.name, P.minVersion, instantiate);
   docWrite("Plugin status: " + getStatusMsg(P));
   docWrite("");
 };


 var INFO = $.getInfo ? $.getInfo(P.name, instantiate) : null;
 if (INFO)
 {

    docWrite("Plugin is scriptable: " + (INFO.Scriptable ? "true" : "false"));

    if (INFO.DllPlugin && !INFO.FirefoxPlugin)
    {
       docWrite("");
       docWrite("Note: It appears you are using the old Windows Media Player plugin (Dynamic Link Library).")
       docWrite("We recommend that you upgrade to the Windows Media Player Firefox plugin.");
    };
   
    if (INFO.DllPlugin && INFO.FirefoxPlugin)
    {
       docWrite("");
       docWrite("Note: you appear to have BOTH the old Windows Media Player plugin (Dynamic Link Library) " +
         "AND the new Windows Media Player Firefox plugin. You can disable the old plugin " +
         "in your browser to avoid any potential conflict between the two." );
    };
 
    if (P.status===0 && INFO.FirefoxPlugin)
    {
       docWrite("");
       docWrite("Note: if you want the plugin version to be detected, then you will need to use the " +
         "'instantiate' input argument.");
       docWrite("You may also have to give your browser security permission to run the plugin.");
    };

 };

 
 if ($.browser.isIE)
 {
    docWrite("");
    docWrite("ActiveX enabled / ActiveX scripting enabled: " +
      ($.browser.ActiveXEnabled ? "true" : "false [this may prevent the plugin from running in Internet Explorer]")
    );
    docWrite("ActiveX Filtering enabled: " +
      ($.browser.ActiveXFilteringEnabled ? "true [this may prevent the plugin from running in Internet Explorer]" : "false")
    );
 };



})(); // end of function
